import Mail from './Mail.vue';
import Clipboard from './Clipboard.vue';
import Mobile from './Mobile.vue';
import Whatsapp from './Whatsapp.vue';

const shareActions = {
  mail: Mail,
  clipboard: Clipboard,
  mobile: Mobile,
  whatsapp: Whatsapp,
};

export default shareActions;
